<template>
  <div class="history">
    <van-nav-bar title="历史浏览" fixed left-arrow @click-left="goBack">
      <van-icon slot="right" @click="emptyGoods()">清空</van-icon>
    </van-nav-bar>
    <div class="van-content">
      <div class="nodata text-cent" v-if="finished && datas == ''">
        <P class="imgbox">
          <img src="/static/images/nodataimg7.png"/>
        </P>
        <p class="text">还没有记录哦~</p>
      </div>
      <van-list v-model="loading" :finished="finished" @load="getDatas" :offset="-1">
        <van-swipe-cell :right-width="50" :left-width="0" v-for="(items,index) in datas" :key="items.id">
          <span slot="left">选择</span>
          <van-cell-group>
            <van-card class="goodsonelist">
              <router-link slot="thumb" class="goodsimgbox"  :to="{path:'/goodslist/goods',query:{id:items.id}}">
                <img onerror="src='/static/errorimg1.png'" :src="items.product_img">
              </router-link>
              <div slot="title" class="ellipseal van-card-title">
                <p class="tagbox">
                  <van-tag class="theme-bg theme-bd" v-if="items.is_new == 1">新品</van-tag>
                  <van-tag class="theme-bg theme-bd" v-if="items.is_hot == 1">热销</van-tag>
                  <van-tag class="theme-bg theme-bd" v-if="items.is_rob == 1">限时</van-tag>
                </p>
                <div class="ellipseal">
                  <van-tag plain class="theme-col theme-bd jd" v-if="items.dummy == 3">优选</van-tag>{{ items.product_name }}
                </div>
              </div>
              <div slot="desc" class="van-card-desc theme-col">{{ items.points_price }} </div>
              <div slot="footer">
                <van-icon class="iconfont icon-gouwuche1 theme-col ft3" @click.stop="addCart(items.id)" v-if="items.dummy == 0"></van-icon>
              </div>
            </van-card>
          </van-cell-group>
          <span slot="right"><button class="clearbtn theme-bd theme-bg" @click="removeGoods(items.id,index)">删除</button></span>
        </van-swipe-cell>
        <div v-if="!loading && finished && datas != ''" class="nomore">没有更多了~</div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      datas: [],
      page: 0,
      finished: false,
      loading: false
    };
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    onClickRight: function() {
      console.log("按钮");
    },
    getDatas: function() {
      var isUser = localStorage.getItem("BLHuser");
      var _this = this;
      setTimeout(() => {
        this.page++;
        this.$api.post(
          "WebApi/Member/History/index",
          { token: isUser, p: this.page },
          res => {
            if (res.data.code == "100") {
              if (res.data.data.length == 0) {
                _this.finished = true;
                _this.loading = false;
              } else {
                for (let i = 0; i < res.data.data.length; i++) {
                  _this.datas.push(res.data.data[i]);
                }
                _this.loading = false;
              }
            } else {
              this.$toast.alert(res.data.message);
              _this.loading = false;
            }
          }
        );
      }, 50);
    },
    removeGoods: function(id, index) {
      var _this = this;
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post(
        "WebApi/Member/History/del",
        { token: isUser, id: id },
        res => {
          if (res.data.code == "100") {
            this.$toast(res.data.message);
            this.datas.splice(index, 1);
            this.$api.post(
              "WebApi/Member/History/index",
              { token: isUser, p: this.page },
              res => {
                if (res.data.code == "100") {
                  if (res.data.data.length != 0) {
                    $.each(res.data.data, function(items, index) {
                      if (!_this.datas[items]) {
                        _this.datas.push(items);
                      }
                    });
                  }
                } else if (res.data.errCode == "1002") {
                  this.$dialog
                    .confirm({
                      title: "提示",
                      message: "您还未登录是否去登录？"
                    })
                    .then(() => {
                      this.$router.push({ path: "/notelogin" });
                    })
                    .catch(() => {
                      // on cancel
                    });
                } else {
                  this.$toast(res.data.message);
                }
              }
            );
          } else {
            this.$dialog
              .confirm({
                title: "提示",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ path: "/notelogin" });
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      );
    },
    addCart: function(id) {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post(
        "WebApi/Member/Cart/addCart",
        {
          token: isUser,
          product_id: id,
          nums: 1,
          city: this.city,
          county: this.county,
          province: this.province,
          town: this.town
        },
        res => {
          if (res.data.code == "100") {
            this.$toast({
              message: res.data.message,
              duration: 500
            });
          } else if (res.data.errCode == "1002") {
            this.$dialog
              .confirm({
                title: "提示",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ path: "/notelogin" });
              })
              .catch(() => {
                // on cancel
              });
          } else {
            this.$toast(res.data.message);
          }
        }
      );
    },
    emptyGoods: function() {
      var isUser = localStorage.getItem("BLHuser");
      this.$api.post("WebApi/Member/History/del", { token: isUser }, res => {
        if (res.data.code == "100") {
          this.datas = [];
          this.$toast(res.data.message);
        } else if (res.data.errCode == "1002") {
          this.$dialog
            .confirm({
              title: "提示",
              message: "您还未登录是否去登录？"
            })
            .then(() => {
              this.$router.push({ path: "/notelogin" });
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.$toast(res.data.message);
        }
      });
    }
  },
  mounted() {
    //this.getDatas()
  }
};
</script>

<style lang="less" scoped>
.history {
  .van-nav-bar__right {
    line-height: 50px;
  }
  .goodsonelist.van-card,
  .goodsonelist {
    margin: 0;
    border: 1px solid #eff3f6;
  }
  .van-cell-group {
    margin-bottom: 0;
  }
  .clearbtn {
    width: 50px;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/history/index.vue